// @flow
import { makeRequest } from 'services/utils';
import strings from 'strings';
import type { OperationResult } from 'types/app';
import { Endpoints } from 'UI/constants/endpoints';

const { BulkUploadAttachment, FilesDelete } = Endpoints;
const { errors: errorsCopies, success: successCopies } = strings.bulkEmails;

export const uploadTemporaryAttachment = async (
  attachmentFormData: FormData
): Promise<OperationResult> =>
  makeRequest({
    url: BulkUploadAttachment,
    data: attachmentFormData,
    method: 'post',
    alertConfig: {
      error: {
        title: errorsCopies.uploadTemporaryAttachments.title
      }
    }
  });

export const deleteTemporaryAttachment = async (id: number): Promise<OperationResult> =>
  makeRequest({
    endpointOptions: {
      path: FilesDelete,
      replaceId: id
    },
    method: 'delete',
    alertConfig: {
      success: {
        title: successCopies.deleteTemporaryAttachments.title,
        body: ({ message }) => message
      },
      error: {
        title: errorsCopies.deleteTemporaryAttachments.title
      }
    }
  });
